(function($) {
    function isUpperCase(str) {
        return str === str.toUpperCase();
    }

    function replaceATSubtitles(findArray, replaceArray) {
        var i, regex = [], map = {}, content;
        for (i = 0; i < findArray.length; i++) {
            regex.push('\\b' + findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1') + '\\b');
            map[findArray[i].replace(' ', '-').toLowerCase()] = replaceArray[i];
        }

        regex = regex.join('|');

        $('.sub-title').each(function() {
            // Check if all string is in uppercase
            if (isUpperCase($(this).html())) {
                content = $(this).html().trim();
                $(this).html(content.charAt(0).toUpperCase() + content.substr(1).toLowerCase()) // str = 'Mac-book pro'
            }

            content = $(this).html();
            $(this).html(content.replace(new RegExp(regex, 'gi'), function (matched) {
                return map[matched.replace(' ', '-').toLowerCase()];
            }));

            $(this).css('opacity', 1);
        });
    }

    var find = [
        'E2E', 'A/B Testing', 'ABM', 'Agilité', 'AMOA', 'Analyse', 'Analytics', 'Analytics Suite', 'Analytics Suite Graduate Program', 'API', 'Applied Technologies Internet', 'Aquitaine Amorçage', 'Assurances', 'AT Internet', 'Banques', 'Big Data', 'Business Intelligences', 'Business Partner', 'CDD', 'CDI', 'CEO', 'Certification', 'Certification TÜV', 'CMS', 'CNIL', 'Commanders Act', 'Consulting', 'CRM', 'DAA', 'Dashboard', 'Data Studio', 'Développement', 'DevOps', 'Digital Analytics', 'Digital Benchmark', 'Directeur des Opérations', 'DPO', 'E-commercants', 'E-commerce', 'Excel', 'FCPI', 'FTP', 'HTML', 'Induction Program', 'In-Page Analytics', 'International', 'JavaScript', 'KPI', 'Leader', 'Marketing Analytics', 'OVH', 'Pardot', 'PHP', 'Power BI', 'Product Management', 'Product Marketing', 'R&D', 'Responsable', 'RGPD', 'RH', 'ROI', 'RTT', 'SaaS', 'Scrum', 'SEO', 'Service Commercial', 'Ship-It', 'SLA', 'SLA Premium', 'Support', 'Tag Management System', 'Top Rated Web Analytics Tool', 'Traffic Manager', 'Trust Radius', 'TV Tracking', 'Union Européenne', 'UX', 'VOD', 'Web Analytics', 'Web Analytics Evangelist','Alain Llorens','Mathieu Llorens','Cyril Mazeau','Jean-Baptiste Roux','Bruno Roy-Contancin','Vincent Lataste','Cédric Ferreira','Laurent de Bar','Hélène Le Pape','Dr. Gérald Bignonneau','Marie Fenner','Adrien Guenther','Louis-Marie Guérif'];

    // Replace words with correct letters
    replaceATSubtitles(find, find);
})(jQuery);
/* in_array() function */
function inArray(needle, haystack) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
    }
    return false;
}

(function ($) {
    $.each(['show', 'hide'], function (i, ev) {
        var el = $.fn[ev];
        $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
        };
    });
})(jQuery);

// Lazy load images
(function ($) {
    $('.lazy-img').Lazy();

    var ll = $('.at-icon');
    var lh = []
    var wscroll = 0;
    var wh = $(window).height();

    function update_offsets(){
        $('.at-icon').each(function(){
            var x = $(this).offset().top;
            lh.push(x);
        });
    };

    function lazy() {
        wscroll = $(window).scrollTop();
        for(i = 0; i < lh.length; i++){
            if(lh[i] <= wscroll + wh){
                $('.at-icon').eq(i).addClass('at-icon-ready');
            };
        };
    };


    $(window).on('load', function() {
        // Page Load
        update_offsets();
        lazy();
    });

    $(window).on('scroll',function(){
        lazy();
    });
})(jQuery);
// --


// Equalize block height
function equalizeHeight() {
    var ph = 0;
    $('.block-logo__container').css('min-height', '');
    $('.alternatelogo').each(function () {
        ph = 0;
        $(this).find('.block-logo__container').each(function () {
            if ($(this).outerHeight() > ph) {
                ph = $(this).outerHeight();
            }
        });

        $(this).find('.block-logo__container').each(function () {
            $(this).css('min-height', ph + 'px');
        });
    });
}
// --

// Set maximum height for flexsliders slides
function fixFlexsliderHeight() {
    if (jQuery('.flexslider').length > 0) {
        // Set fixed height based on the tallest slide
        jQuery('.flexslider').each(function () {
            var sliderHeight = 0;
            jQuery(this).find('.slides > li').each(function () {
                slideHeight = jQuery(this).height();
                if (sliderHeight < slideHeight) {
                    sliderHeight = slideHeight;
                }
            });
            jQuery(this).find('ul.slides').css({'height': sliderHeight});
        });
    }
}

jQuery(window).load(function () {
    fixFlexsliderHeight();
    jQuery('.load-screen').fadeOut(500);

    jQuery(window).resize(function ($) {
        fixFlexsliderHeight();
    });

    equalizeHeight();
});
// --

jQuery(document).ready(function ($) {
    "use strict";

    // Load popup iframe on .btn-pardot-modal click
    // $('.btn-pardot-modal').on('click', function(e) {
    //     // Get associated modal
    //     var modal = $(this).data('target');
    //     if (modal) {
    //         var formContainer = $(modal).find('.form-popup-container');
    //         // Check if there is an iframe already
    //         if (formContainer.find('iframe').length < 1) {
    //             var formId = formContainer.data('form-id');
    //             if (formId) {
    //                 // Load form ajax with associated ID
    //                 $.ajax({
    //                     url: ajaxurl + '?action=get_form_ajax',
    //                     type: "POST",
    //                     data: {
    //                         id: formId
    //                     },
    //                     dataType: "json",
    //                     success: function (data) {
    //                         if (data.status) {
    //                             // Add the iframe to the form container
    //                             formContainer.html(data.output);
    //                             formContainer.find('iframe').each(function() {
    //                                 this.attr('scrolling', 'no');
    //                             });
    //                         }
    //                     }
    //                 });
    //             }
    //         }
    //     }
    // });

    // Disable scrolling on form iframes
    $('.par-form > iframe').attr('scrolling', "no");

    if (typeof $('.venobox').venobox === "function") {
            $('.venobox').venobox({
            'spinColor': '#0cacf8',
            'spinner': 'spinner-pulse'
        });
    }

    $('a[ng-href]').each(function (index, element) {
        $(element).on('click', function (event) {
            event.preventDefault();
            return false;
        });
    });

    $('a[href="#"]').each(function (index, element) {
        $(element).removeAttr('href');
        $(element).attr('ng-href', '#');
    });

    if (is.tablet()) {
        $('.animateme').css('opacity', 1);
        $('.animateme').removeClass('animateme');
        $('.wires').css('width', '97%');
    }

    // Attribute current bootsrap viewport
    var viewCurrentViewport = $.viewportDetect();
    $.viewportDetect(function (currentViewport, previousViewport) {
        viewCurrentViewport = currentViewport;
    });

    /* Language selector */
    var langsOpen = false,
        langsList = $('#langs_selector_list'),
        langElm = $('.quick-menu li.langs'),
        closingTooltipLang;
    langsList.show(0).slideUp(0);
    $('#trig_langs').on('click', function (event) {
        if (langsOpen == false) {
            langElm.addClass('open');
            langsList.stop(false, true).slideDown();
            $(this).find('.fa').removeClass('fa-caret-down').addClass('fa-caret-up');
            if ($('.rich-container').hasClass('rscrolled')) {
                $('.rich-container').addClass('disapear');
                $('.rich-container').removeClass('rscrolled');
                $('.quick-menu').removeClass('deployed');
            }
            langsOpen = true;
        }
        else {
            langElm.removeClass('open');
            langsList.stop(false, true).slideUp();
            $(this).find('.fa').removeClass('fa-caret-up').addClass('fa-caret-down');
            langsOpen = false;
        }
    });
    // Auto Closing
    langElm.hover(function (e) {
        clearTimeout(closingTooltipLang);
    }, function (e) {
        clearTimeout(closingTooltipLang);
        if (langsOpen == true) {
            closingTooltipLang = setTimeout(function () {
                langElm.removeClass('open');
                langsList.stop(false, true).slideUp();
                langElm.find('.fa').removeClass('fa-caret-up').addClass('fa-caret-down');
                langsOpen = false;
            }, 500);
        }
    });

    /* SELECT 2 */
    $('select').select2();

    /* Style input[type=file] */
    $(':file').filestyle();

    $('#toggle-one-click').on('click', function (ev) {
        var overlay = $('#overlay');
        var overlayDark = $('#overlay_dark');
        var oneclick = $('#at-one-click');

        if (overlay.hasClass('active')) {
            overlay.removeClass('active');
            oneclick.removeClass('active');
            overlayDark.removeClass('active');
        } else {
            overlay.addClass('active');
            oneclick.addClass('active');
            overlayDark.addClass('active');
        }

        return ev.preventDefault();
    });

    $('#overlay_dark').on('click', function (ev) {
        $('#overlay').removeClass('active');
        $('#at-one-click').removeClass('active');
        $(this).removeClass('active');
    });

    //Close Video of 'toggle-one-click'
    $('#close_overlay').on('click', function () {
        $('#overlay').removeClass('active');
        $('#at-one-click').removeClass('active');
        $('#overlay_dark').removeClass('active');
    });

    // close mobile menu
    $('.closemenu-m').on('click', function () {
        $('.closemenu-m').removeClass('visible-slide');
    });

    // search button
    $('.search .loupe').on('click', function () {
        if ($(window).width() >= 768) {
            if (!$('.request-button').hasClass('on-search') && !$('.search').hasClass('on-search')) {
                $('.request-button ').addClass('on-search');
                $('.search').addClass('on-search');
            } else {
                $('.request-button ').removeClass('on-search');
                $('.search').removeClass('on-search');
            }
        } else {
            if (!$('.quick-menu').hasClass('on-search-m')) {
                $('.quick-menu').addClass('on-search-m');
                langElm.removeClass('open');
                langsList.stop(false, true).slideUp();
                $('#trig_langs').find('.fa').removeClass('fa-caret-up').addClass('fa-caret-down');
                langsOpen = false;
            } else {
                $('.quick-menu').removeClass('on-search-m');
            }
        }
    });

    $('.search .closer').on('click', function () {
        $('.quick-menu').removeClass('on-search-m');
    });

    $(window).bind('scroll', function () {
        var scrollTop = $(window).scrollTop();
        var quickMenu = $('.quick-menu');
        var richContainer = $('.rich-container');
        // Make main menu disapear
        if (scrollTop > 20) {
            if (!richContainer.hasClass('disapear') && !quickMenu.hasClass('smaller')) {
                richContainer.addClass('disapear');
                richContainer.removeClass('rscrolled');
                quickMenu.addClass('smaller');
            }

            if (scrollTop > 80) {
                quickMenu.addClass('scrolled');
            }
            else {
                quickMenu.removeClass('scrolled');
            }
        }
        else {
            $('.rich-container').removeClass('disapear');
            $('.rich-container').removeClass('rscrolled');
            quickMenu.removeClass('smaller');
            quickMenu.removeClass('deployed');
            quickMenu.removeClass('scrolled');
        }

        if ($('.icono-home').length > 0) {
            if ($(window).scrollTop() > $('.icono-home').offset().top - ($('.icono-home').outerHeight() / 3)) {
                $('.bullet-anim').css({
                    transform: 'none',
                    opacity: 1
                });
            }
        }
    });
    $(window).scroll();

    // burger
    $('.toggle-menu .hb').on('click', function () {
        if ($(window).width() >= 768) {

            $('.rich-container').toggleClass('disapear');
            $('.rich-container').toggleClass('rscrolled');
            $('.quick-menu').toggleClass('deployed');

            if ($('.quick-menu').hasClass('deployed'))
                $('.rich-container').removeClass('disapear');
            else
                $('.rich-container').addClass('disapear');

            if (window.scrollY > 0)
                $('.quick-menu').addClass('smaller');
            else {
                $('.rich-container').removeClass('disapear');
                $('.quick-menu').removeClass('smaller');
            }
        }
    });

    /* Screen Advancement */
    var nbScreen = $('.step').length;
    var nbScreenContent = $('.screen-content').length;
    if (nbScreen > 1) {
        var stepScreen = 100 / nbScreen;
        $('.screen-title .step').width(stepScreen + "%");
        $('.screen-title .step').each(function (i) {
            var curPos = i * stepScreen;
            $(this).css('left', curPos + "%");
        });
    }

    if ($('.list-resources').length > 0) {
        $('.bloc-resource').on('mouseover', function () {
            var imagebg = $(this).find('.thumb').attr('data-imagebg');
            $(this).find('.thumb').css('background-image', imagebg);
        });
        $('.bloc-resource').on('mouseout', function () {
            var colorbg = $(this).find('.thumb').attr('data-colorbg');
            $(this).find('.thumb').css('background-image', colorbg);
        })
    }

    /* Bullets Toggle */
    $('.bullet-inner').not('.active').slideUp(0);

    $('.icono-home').each(function () {
        var bulletActive = $(this).find('.bullet-inner.active').attr('id');
        $(this).find('a.bullet-link').on('click', function () {
            if (viewCurrentViewport == 'xs') {
                return;
            }
            var linkElm = $(this);
            var bulletContainerId = linkElm.data('tab');
            // Assign Current Clicked Button
            bulletContainerId = bulletContainerId.replace('_tab', '_content');
            var bulletContainer = $('#' + bulletContainerId);
            // Alleready Open
            if (bulletActive == bulletContainerId) {
                return false;
            }
            else {
                // Retieve Old Clicked Button
                var bulletActiveId = bulletActive;
                var activeBulletContainer = bulletActive.replace('_tab', '_content');
                activeBulletContainer = $('#' + activeBulletContainer);
                // Assign current clicked button
                bulletActive = linkElm.data('tab');
                // Close active button
                activeBulletContainer.hide();
                $(this).parents('.screen').find('.bullet-link').removeClass('active');
                activeBulletContainer.removeClass('active');
                $('#' + bulletActive).addClass('active');
                bulletContainer.addClass('active');
                $(bulletContainer).fadeIn(300);
            }
        });
    });

    $('.sidr-class-rich-main-item').on('click', function (event) {
        var whatOpen = $(this).parent().find('.sidr-class-rich-s-menu');
        var laFleche = $(this).find('.sidr-class-fa');
        if (!$(whatOpen).hasClass('open-smenu')) {
            $(whatOpen).addClass('open-smenu');
            $(laFleche).addClass('open-smenu');
            $(this).addClass('open-smenu');
            $(whatOpen).removeClass('close-smenu');
            $(laFleche).addClass('close-smenu');
            $(this).removeClass('close-smenu');
        }
        else {
            $(whatOpen).addClass('close-smenu');
            $(laFleche).addClass('close-smenu');
            $(this).addClass('close-smenu');
            $(whatOpen).removeClass('open-smenu');
            $(laFleche).removeClass('open-smenu');
            $(this).removeClass('open-smenu');
        }
    });

    if ($('.lightbox-link').length > 0) {
        $('.lightbox-link').click(function (e) {
            e.preventDefault();
        });
    }
    $('.ref-item-ie').hover(
        function () {
            $(this).find('image').attr('filter', 'url()');
        },
        function () {
            $(this).find('image').attr('filter', 'url(#grayscale)');
        }
    );

    // SIDR
    function setSidr() {
        if (window.matchMedia("(max-width: 767px)").matches) {
            $('#sidr-main').show();

            $('#responsive-button').sidr({
                source: '.search:not(body), #at_rich_menu',
                name: 'sidr-main',
                side: 'left',
                onOpen: function () {
                    $('.closemenu-responsive').addClass('mopen');
                },
                onClose: function () {
                    $('.closemenu-responsive').removeClass('mopen');
                }
            });

            $('.closemenu-m').sidr({
                source: '.search:not(body), #at_rich_menu',
                name: 'sidr-main',
                side: 'left',
                onOpen: function () {
                    $('.closemenu-responsive').addClass('mopen');
                },
                onClose: function () {
                    $('.closemenu-responsive').removeClass('mopen');
                }
            });

            $('.sidr-class-rich-main-item').each(function (index, element) {
                $(element).attr('href', '#');
            });

            $('.sidr-class-rich-main-item').on('click', function (e) {

                var element = $(e.target);
                console.log(element);
                console.log(element.hasClass('sidr-class-has-dropdown'));


                if (element.hasClass('is-linkable')) {
                    var url = element.data('url');
                    window.location = url;
                    e.preventDefault();
                    return false;
                }

                if (!$(element).is('i')) {
                    element.addClass('is-linkable');
                }
                else {
                    $(element).parent().addClass('is-linkable');
                    element = $(element).parent();
                }

                var links = element.find('+ ul a');
                var length = 0;

                $(links).each(function (index, element) {
                    var l = $(element).text();
                    length += l;
                });


                if (length == 0) {
                    e.preventDefault();
                    return false;
                }

                var list = element.find('+ ul');
                $(list).toggle();
                $(list).find('ul').toggle();
                element.toggleClass('is-expanded');
                element.find('i').toggleClass('open-smenu');
            });
        }
    }

    setSidr();

    equalizeHeight();

    $(window).on('resize', function () {
        equalizeHeight();
    });

    /**
     * Shortcode imgleft/textright imgright/textleft
     */
    $('.text-aleft426').each(function () {
        var next = $(this).next('.img-aright426');
        if (next.hasClass('img-aright426')) {
            var current = $(this);
            var currentHeight = current.outerHeight();
            var nextHeight = next.outerHeight();
            if (currentHeight < nextHeight) {
                current.css('min-height', nextHeight);
            }
            else {
                next.css('min-height', currentHeight);
            }
        }
    });
    $('.img-aleft426').each(function () {
        var next = $(this).next('.text-aright426');
        if (next.hasClass('text-aright426')) {
            var current = $(this);
            var currentHeight = current.outerHeight();
            var nextHeight = next.outerHeight();
            if (currentHeight < nextHeight) {
                current.css('min-height', nextHeight);
            }
            else {
                next.css('min-height', currentHeight);
            }
        }
    });


    // Back to top
    var offset = 300,
        offset_opacity = 1200,
        scroll_top_duration = 700,
        $back_to_top = $('.cd-top');

    $(window).scroll(function () {
        ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
        if ($(this).scrollTop() > offset_opacity) {
            $back_to_top.addClass('cd-fade-out');
        }
    });

    $back_to_top.on('click', function (event) {
        event.preventDefault();
        $('body,html').animate({
                scrollTop: 0,
            }, scroll_top_duration
        );
    });


    if ($('.form-type').length > 0 && nbScreen < 2 && nbScreenContent < 2) {
        //If the page contains a form only (no other screen)
        var target = $('.form-type');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top
            }, 1000);
            return false;
        }
    }

    // Check old browser
    if (is.ie(6) || is.ie(7) || is.ie(8)) {
        swal({
            title: '<div class="img-old-browser"></div><div class="cross"><span></span></div>',
            text: '<div class="old-nav-title">' + atVars.oldNavTitle + '<div><div class="old-nav-text">' + atVars.oldNavText + '<div>',
            html: true,
            showConfirmButton: false,
            customClass: 'old-browser-window'
        });

        $('body').on('click', function (ev) {
            swal.close();
        })
    }
    ;

    $('.at-collapse__title').on('click', function (e) {
        e.preventDefault();
        var next = $(this).next('.at-collapse__content');
        $(this).toggleClass('at-collapse__title--active');
        next.toggleClass('at-collapse__content--hide');
        if (next.hasClass('at-collapse__content--hide')) {
            next.slideUp();
        }
        else {
            next.slideDown();
        }
    });

    $('.expertises').on('click', '.expertise__button', function (e) {
        e.preventDefault();
        $(this).hide();
        $('.expertise__block').each(function (i, el) {
            if ($(el).hasClass('hide')) {
                $(el).removeClass('hide');
            }
        });
    });

    $('.cms-content__reveal').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).prev('.cms-content--hidden').slideToggle();
    });

    $('.card__more').on('click', function (e) {
        e.preventDefault();
        $('.card--hidden').addClass('animated');

        // If blocks are displayed, add exit classes
        if ($(this).hasClass('active')) {
            $('.card--hidden').removeClass('fadeInUp').addClass('fadeOutDown').delay(1000).fadeOut();
        }
        else {
            $('.card--hidden').css('display', '').addClass('fadeInUp').removeClass('fadeOutDown');
        }

        $(this).toggleClass('active');
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('.header-popup__slide').on('click', function (e) {
        e.preventDefault();
        $('#header-popup').attr('src', $(this).data('src'));
        $('.header-popup__overlay').fadeIn(400, function () {
            $('.header-popup__popup').show();
        });
    });

    $('.header-popup__overlay, .header-popup__close').on('click', function (e) {
        e.preventDefault();
        $('.header-popup__popup').hide();
        $('.header-popup__overlay').fadeOut(400, function () {
            $('#header-popup').attr('src', '');
        });
    });


    // DELTA BANNER

    function positionDeltaBanner() {

        if($('#footer_tc_privacy').length){  // if cookie banner is visible

            let cookieBannerHeight = $('#footer_tc_privacy').height();
            if(cookieBannerHeight){
                $('.ub-emb-bar-frame').attr('style', 'bottom: ' + cookieBannerHeight +'px !important');
            }

            $(window).scroll(function(){
                let cookieBannerHeight = $('#footer_tc_privacy').height();
                if(cookieBannerHeight){
                    $('.ub-emb-bar-frame').attr('style', 'bottom: ' + cookieBannerHeight +'px !important');
                }
            });

        }else {  // if cookie banner is not visible

            $('.ub-emb-bar-frame').addClass('delta-banner-under');
            $('.ub-emb-bar-frame').attr('style', 'bottom: 0!important');
            let privacyButton = $('.privacy-center-cta');
            let deltaBanner = $('.ub-emb-bar-frame');
            let deltaBannerHeight = deltaBanner.height()
            privacyButton.addClass('delta-position');

            if ($(window).width() < 768) {
                privacyButton.attr('style', 'bottom: ' + (deltaBannerHeight + 60) +'px !important');
                $('.ub-emb-bar-frame').attr('style', 'bottom: 60px!important');
            }else {
                privacyButton.attr('style', 'bottom: ' + deltaBannerHeight +'px !important');
            }

            $(window).scroll(function(){
                if ($(window).width() < 768) {
                    privacyButton.attr('style', 'bottom: ' + (deltaBannerHeight + 60) +'px !important');
                    $('.ub-emb-bar-frame').attr('style', 'bottom: 60px!important');
                }else {
                    privacyButton.attr('style', 'bottom: ' + deltaBannerHeight +'px !important');
                }

            });
        }

    }

    positionDeltaBanner();

    // on cookie banner close
    $('#footer_tc_privacy_button_2').on('click', function (e) {
        positionDeltaBanner();
    });


    $(window).scroll(function(){
        positionDeltaBanner();
    });


});

(function ($) {
    // Set unique values for the array "ar"
    function uniqueArray(ar) {
        var j = {};

        ar.forEach(function (v) {
            j[v + '::' + typeof v] = v;
        });

        return Object.keys(j).map(function (v) {
            return j[v];
        });
    }

    // Equalize blocks height by setting the same min-height value
    function equalizeBlocks() {
        var blockArray = $('[data-eq]').map(function () {
            return $(this).data('eq');
        }).get();
        var blocks = uniqueArray(blockArray);

        blocks.forEach(function (elem) {
            var prev = 0;
            $('[data-eq="' + elem + '"]')
                .css('min-height', '')
                .each(function () {
                    if ($(this).outerHeight() > prev) {
                        prev = $(this).outerHeight();
                    }
                })
                .css('min-height', prev + 'px');
        });
    }

    // Equalize on page load
    $(window).on('load', function () {
        equalizeBlocks();
    });

    // Equalize on page resize
    $(window).resize(function () {
        equalizeBlocks();
    });
})(jQuery);

// Scroll to anchor
(function ($) {
    $(window).on('load', function () {
        // Scroll to anchor on page init
        var hash = window.location.hash.substring(1);
        var target = $('#' + hash);

        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 50
            }, 1000);
            return false;
        }
    });
})(jQuery);

(function ($) {
    jQuery(document).ready(function ($) {
        function morphDropdown(element) {
            this.element = element;
            this.mainNavigation = this.element.find('.main-nav');
            this.mainNavigationItems = this.mainNavigation.find('.has-dropdown');
            this.dropdownList = this.element.find('.dropdown-list');
            this.dropdownWrappers = this.dropdownList.find('.dropdown');
            this.dropdownItems = this.dropdownList.find('.content');
            this.dropdownBg = this.dropdownList.find('.bg-layer');
            this.mq = this.checkMq();
            this.bindEvents();
        }

        morphDropdown.prototype.checkMq = function () {
            //check screen size
            var self = this;
            return window.getComputedStyle(self.element.get(0), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "").split(', ');
        };

        morphDropdown.prototype.bindEvents = function () {
            var self = this;
            //hover over an item in the main navigation
            this.mainNavigationItems.mouseenter(function (event) {
                //hover over one of the nav items -> show dropdown
                self.showDropdown($(this));
            }).mouseleave(function () {
                setTimeout(function () {
                    //if not hovering over a nav item or a dropdown -> hide dropdown
                    if (self.mainNavigation.find('.has-dropdown:hover').length == 0 && self.element.find('.dropdown-list:hover').length == 0) self.hideDropdown();
                }, 50);
            });

            //hover over the dropdown
            this.dropdownList.mouseleave(function () {
                setTimeout(function () {
                    //if not hovering over a dropdown or a nav item -> hide dropdown
                    (self.mainNavigation.find('.has-dropdown:hover').length == 0 && self.element.find('.dropdown-list:hover').length == 0 ) && self.hideDropdown();
                }, 50);
            });

            //click on an item in the main navigation -> open a dropdown on a touch device
            this.mainNavigationItems.on('touchstart', function (event) {
                var selectedDropdown = self.dropdownList.find('#' + $(this).data('content'));
                if (!self.element.hasClass('is-dropdown-visible') || !selectedDropdown.hasClass('active')) {
                    event.preventDefault();
                    self.showDropdown($(this));
                }
            });

            //on small screens, open navigation clicking on the menu icon
            this.element.on('click', '.nav-trigger', function (event) {
                event.preventDefault();
                self.element.toggleClass('nav-open');
            });
        };

        morphDropdown.prototype.showDropdown = function (item) {
            this.mq = this.checkMq();
            if (this.mq == 'desktop') {
                var self = this;
                var selectedDropdown = this.dropdownList.find('#' + item.data('content')),
                    selectedDropdownHeight = selectedDropdown.innerHeight(),
                    selectedDropdownWidth = selectedDropdown.children('.content').innerWidth(),
                    selectedDropdownLeft = item.offset().left + item.innerWidth() / 2 - selectedDropdownWidth / 2
                arrowLeft = item.offset().left + item.innerWidth() / 2;

                var menuContainer = $('#at_rich_menu');

                // force the popup left side inside the container
                if (menuContainer.offset().left - selectedDropdownLeft > 0) {
                    selectedDropdownLeft += menuContainer.offset().left - selectedDropdownLeft;
                }

                // force the popup right side inside the container
                if (selectedDropdownLeft + selectedDropdownWidth > menuContainer.offset().left + menuContainer.innerWidth()) {
                    selectedDropdownLeft = selectedDropdownLeft - ((selectedDropdownLeft + selectedDropdownWidth) - (menuContainer.offset().left + menuContainer.innerWidth()));
                }

                // change arrow position
                arrowLeft = arrowLeft - selectedDropdownLeft;

                // update dropdown position and size
                this.updateDropdown(selectedDropdown, parseInt(selectedDropdownHeight), selectedDropdownWidth, parseInt(selectedDropdownLeft));

                $('.dropdown-arrow').css({
                    '-moz-transform': 'translateX(' + arrowLeft + 'px) rotate(45deg)',
                    '-webkit-transform': 'translateX(' + arrowLeft + 'px) rotate(45deg)',
                    '-ms-transform': 'translateX(' + arrowLeft + 'px) rotate(45deg)',
                    '-o-transform': 'translateX(' + arrowLeft + 'px) rotate(45deg)',
                    'transform': 'translateX(' + arrowLeft + 'px) rotate(45deg)',
                });

                //add active class to the proper dropdown item
                this.element.find('.active').removeClass('active');
                selectedDropdown.addClass('active').removeClass('move-left move-right').prevAll().addClass('move-left').end().nextAll().addClass('move-right');
                item.addClass('active');
                //show the dropdown wrapper if not visible yet
                if (!this.element.hasClass('is-dropdown-visible')) {
                    setTimeout(function () {
                        self.element.addClass('is-dropdown-visible');
                    }, 10);
                }
            }
        };

        morphDropdown.prototype.updateDropdown = function (dropdownItem, height, width, left) {
            this.dropdownList.css({
                '-moz-transform': 'translateX(' + left + 'px)',
                '-webkit-transform': 'translateX(' + left + 'px)',
                '-ms-transform': 'translateX(' + left + 'px)',
                '-o-transform': 'translateX(' + left + 'px)',
                'transform': 'translateX(' + left + 'px)',
                'width': width + 'px',
                'height': height + 'px'
            });

            this.dropdownBg.css({
                'width': width + 'px',
                'height': height + 'px'
            })
        };

        morphDropdown.prototype.hideDropdown = function () {
            this.mq = this.checkMq();
            if (this.mq == 'desktop') {
                this.element.removeClass('is-dropdown-visible').find('.active').removeClass('active').end().find('.move-left').removeClass('move-left').end().find('.move-right').removeClass('move-right');
            }
        };

        morphDropdown.prototype.resetDropdown = function () {
            this.mq = this.checkMq();
            if (this.mq == 'mobile') {
                this.dropdownList.removeAttr('style');
            }
        };

        var morphDropdowns = [];
        if ($('.at-menu-dropdown').length > 0) {
            $('.at-menu-dropdown').each(function () {
                //create a morphDropdown object for each .at-menu-dropdown
                morphDropdowns.push(new morphDropdown($(this)));
            });

            var resizing = false;

            //on resize, reset dropdown style property
            updateDropdownPosition();
            $(window).on('resize', function () {
                if (!resizing) {
                    resizing = true;
                    (!window.requestAnimationFrame) ? setTimeout(updateDropdownPosition, 300) : window.requestAnimationFrame(updateDropdownPosition);
                }
            });

            function updateDropdownPosition() {
                morphDropdowns.forEach(function (element) {
                    element.resetDropdown();
                });

                resizing = false;
            };
        }

        //sticky CTA + popups

        setTimeout(function() {
            $('.sticky-ctas__link').addClass('sticky-ctas--small');
        }, 5000);

        // $("#sticky-ctas__chat").on("click touch", function() {
        //     $("#message-modal").modal('toggle');
        // })


        // Arrow scroll to next section
        $('.arrow-scroll').click(function (e) {
            var jump = $('#at-main-content');
            var sectionPosition = $(jump).offset();
            $('html, body').stop().animate({scrollTop: sectionPosition.top - 88}, 500); //88 is header height
            e.preventDefault();
        });

        function resizeCasestudyBoxes() {
            $(".casestudy__numbers__box").each( function() {
                $(this).height($(this).width());
            });
        }
        resizeCasestudyBoxes();
        $(window).resize(function () {
            resizeCasestudyBoxes();
        });


        // Check if tag commander cookie is set

        function getCookie(name) {
            var dc = document.cookie;
            var prefix = name + "=";
            var begin = dc.indexOf("; " + prefix);
            if (begin == -1) {
                begin = dc.indexOf(prefix);
                if (begin != 0) return null;
            }
            else
            {
                begin += 2;
                var end = document.cookie.indexOf(";", begin);
                if (end == -1) {
                    end = dc.length;
                }
            }
            // because unescape has been deprecated, replaced with decodeURI
            //return unescape(dc.substring(begin + prefix.length, end));
            return decodeURI(dc.substring(begin + prefix.length, end));
        }

        function showPrivacyButton() {
            var privacyCookie = getCookie("TC_PRIVACY");

            if (privacyCookie == null) {
                // Don't show privacyButton

            }
            else {
                // Show Privacy Button
                $('.privacy-center-cta').show();
            }

            if($('#footer_tc_privacy').is(":hidden")){
                // Show Privacy Button
                $('.privacy-center-cta').show();
            }

        }

        showPrivacyButton();
        window.setInterval(showPrivacyButton, 100);

        $('.banner-form').on('submit', function(e) {
            e.preventDefault();
            $('#banner-form-modal input[name=email]').val($(this).find('input[name=email]').val());
            $('#banner-form-modal').modal('show');
            return false;
        });

        /*
        // Ajax call to Pardot form handler : UNSUPPORTED by pardot, receiving error:
        "Access to XMLHttpRequest at 'http://go.atinternet.com/l/734293/2020-02-24/4dwqt' from origin 'http://atinternet.local' has been blocked by CORS policy: No 'Access-Control-Allow-Origin' header is present on the requested resource."

        $('.banner-form-slider').on('submit', function(e) {
            e.preventDefault();
            var data = $(this).serialize();
            $.ajax({
                url: $(this).attr('action'),
                type: "POST",
                data: data,
                success: function (result) {
                    console.log(result);
                }
            });
        })
        */

    });

    $(document).on("click", "#footer_tc_privacy_button", function() {
        $('.privacy-center-cta').slideDown();
    });

    // Privacy text cta
    $('.privacy-text-cta').on('click', function() {
        window.tC.privacyCenter.showPrivacyCenter();
        return false
    });

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    
    // Sliding anchor links

    $('.anchor-link').on('click', function(e) {
        e.preventDefault();
        var anchorId = $(this).attr('href');
        scrollToAnchor(anchorId);
    });

    function scrollToAnchor(id){
        var block = $(id);
        $('html,body').animate({scrollTop: block.offset().top},1500);
    }


    function getCookie(name) {
        var dc = document.cookie;
        var prefix = name + "=";
        var begin = dc.indexOf("; " + prefix);
        if (begin == -1) {
            begin = dc.indexOf(prefix);
            if (begin != 0) return null;
        }
        else
        {
            begin += 2;
            var end = document.cookie.indexOf(";", begin);
            if (end == -1) {
                end = dc.length;
            }
        }
        // because unescape has been deprecated, replaced with decodeURI
        //return unescape(dc.substring(begin + prefix.length, end));
        return decodeURI(dc.substring(begin + prefix.length, end));
    }

    function checkIfPardotFormCookieExists() {
        var myCookie = getCookie("visitor_id734293");

        if (myCookie == null) {
            //Pardot Form Cookie Does Not Exists;
            var tcCookie = getCookie("TC_PRIVACY");

            if (!(tcCookie == null)) {
                //TC_PRIVACY Cookie Exists;
                observe_pi_tracking_opt_in_div();
            }
        }
        else {
            // Cookie exists
            //Pardot Form Cookie Exists;
        }
    }
    checkIfPardotFormCookieExists();

    function observe_pi_tracking_opt_in_div() {
        var limitOfMutations = 0;
        var dom_observer = new MutationObserver(function(mutation) {
            if ($('#pi_tracking_opt_in_div').length) {
                dom_observer.disconnect();
                $('#pi_tracking_opt_in_div').each( function () {
                    window.piEnableTracking(this);
                    return false;

                });
            }
            if (limitOfMutations > 100) {
                dom_observer.disconnect();
            }
            limitOfMutations = limitOfMutations + 1;

        });
        var container = document.body;
        var config = { attributes: true, childList: true, characterData: true, subtree:false };
        dom_observer.observe(container, config);

        // Set timeOut to stop observing after 15seconds

        setTimeout(function(){
            //15 seconds, time to stop;
            dom_observer.disconnect();
        }, 20000);

    }

    $('.at-privacy-optout').on('click', function() {

        if (typeof window.ATTag.privacy !== 'undefined') {
            window.ATTag.privacy.setVisitorOptout();

            swal({
                title: atVars.atOptoutThankYou,
                html: atVars.atOptoutMsg + '<br><br>',
                type: "success"
            });
        }
    });

})(jQuery);

